import { UserRights } from '../../../entities/User'

export const mapRightsNoPermissionToNull = (rights: UserRights) => {
	const result = {}

	for (const key in rights) {
		// @ts-ignore
		if (rights[key] !== 'noPermission') result[key] = rights[key]
	}

	return result
}